import React from 'react'
import BaseInput, { CommonInputProps } from './BaseInput'

interface NumberInputprops extends CommonInputProps {
	value: string | undefined | null
	onChange?: (value: string) => void
	label: string
}

const NumberInput: React.FC<NumberInputprops> = ({
	value,
	onChange,
	label,
	readonly,
	helperText,
}: NumberInputprops): JSX.Element => {
	const handleChange = (value: string | number | undefined) => {
		if (!onChange) return
		if (value) {
			onChange(value.toString())
		} else {
			onChange('')
		}
	}

	return (
		<BaseInput
			helperText={helperText}
			readonly={readonly}
			label={label}
			value={value?.toString() ?? '0'}
			onChange={handleChange}
			type='number'
		/>
	)
}

export default NumberInput
